// false values will be dropped from the exported object, ex: "", null, undefined, 0
var front_end_url = window.location.origin
var path_url = window.location.pathname
var serverUrl = front_end_url+"/gateway"
//font_end_url.replace("play","gateway");
var billing_url = front_end_url; //.replace("play.","");
console.log("Server Url ", serverUrl)

const config = Object.freeze({
  FACEBOOK_APPID: "1425265207779405",
  BILLING_URL: billing_url,
  ONE_SIGNAL_APPID: "7013f7f6-3310-448a-92a7-95b4008877c2", // local one signal api key
  BIDNWIN_S3_IMAGE_URL:"https://di7iff3954bd3.cloudfront.net/bidnwin-telco/images", // bidnwin-telco S3 bucket
  MRBIDNWIN_S3_IMAGE_URL:"https://di7iff3954bd3.cloudfront.net/mrbidnwin/images", // mrbidnwin S3 bucket
  MRBIDNWIN_S3_IMAGE_URL_REVAMP:"https://di7iff3954bd3.cloudfront.net/mrbidnwin/images_revamped", // mrbidnwin S3 bucket
  BIDNWIN_S3_IMAGE_URL_NEW_UI:"https://di7iff3954bd3.cloudfront.net/bidnwin-telco/new-ui/images", // mrbidnwin S3 bucket new UI
  CLIENT_ID: "ce7e0a22-dbdf-429d-ac2c-58b337683c72",
  GA_ID: "UA-123279590-1", // production google analytics tracking id
  //GA_ID: "UA-128068186-1", // test google analytics tracking id
  NETWORK_URL: serverUrl, // production server url
  // NETWORK_URL: "http://172.21.29.169:8080", // himanshu server url
  // NETWORK_URL: "http://10.121.15.168:9091", // test server url
  NON_WIFI_OP: "vgh",
  NON_WIFI_OP_U2: "u2",
  NO_LOGIN_OP: "vgh_VFGH",
  termscondition_header: "Terms And Condition",
  LICENSE_TO_USE: "LICENSE TO USE",
  CG_FLOW_OP: "epu,",
  COVID_POPUP_DOMAIN: "epu,",
  TESTIMONIALS_OP: "mgh,",
});

export default config



// WEBPACK FOOTER //
// ./src/Config.js